export function hardNavigate(path: string): void {
  window.location.assign(path);
}
